import { ChevronRight, Check } from "lucide-react";

interface Props {
  currentIndex: number;
  steps: {
    title: string | null;
    description: string | null;
  }[];
}

export const OnboardingProgress = ({ currentIndex, steps }: Props) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-y-4">
      {steps.map((step, index) => {
        const isComplete = currentIndex > index;
        const isActive = currentIndex === index;

        return step.title ? (
          <div key={index} className="flex items-center">
            <div className="flex h-28 w-52 flex-col items-center space-y-2">
              <div
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${
                  isComplete
                    ? "bg-green-500 text-white"
                    : isActive
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-500"
                } `}
              >
                {isComplete ? <Check className="h-5 w-5" /> : index + 1}
              </div>
              <div className="min-w-52 text-center text-sm">
                <div className="font-medium">{step.title}</div>
                <div className="text-muted-foreground text-xs">
                  {step.description}
                </div>
              </div>
            </div>
            {steps[index + 1]?.title && (
              <ChevronRight className="mx-4 h-5 w-5 text-gray-400" />
            )}
          </div>
        ) : null;
      })}
    </div>
  );
};
